import React, { Fragment } from "react";
import Header2 from "../../components/header/Header2";
import { Link } from "react-router-dom";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import CtaSection from "../../components/CtaSection/CtaSection";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/eye-icon.svg";
import caseImg from "../../images/testimonial/sa-tes01.jpg";
import cIcon1 from "../../images/icon/csd-icon01.svg";
import cIcon2 from "../../images/icon/csd-icon02.svg";
import cIcon3 from "../../images/icon/csd-icon03.svg";
import cIcon4 from "../../images/icon/csd-icon04.svg";
import cIcon from "../../images/icon/check-icon.svg";
import caseStudies from "../../api/case";

const CaseStudyMigracaoCloudVPS = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 />
        <section
          className="page-title pt-200 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-9 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      <img src={icon} alt="" /> Caso de Sucesso
                    </span>
                    <h2 className="title">
                      Migração completa para Cloud VPS <br /> reduzindo custos
                      em 78% <br /> para indústria alimentícia
                    </h2>
                  </div>
                </div>
                <div className="col-lg-3 mt-30">
                  <div className="count-box">
                    <h2 className="number">
                      78<span className="suffix">%</span>
                    </h2>
                    <span className="text">
                      redução de custos <br /> operacionais
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="csd-img pt-70 pb-65">
          <div className="container">
            <div className="item-details_image pos-rel">
              <img
                src={caseImg}
                alt="Migração Cloud VPS - Indústria Alimentícia"
              />
            </div>
          </div>
        </div>
        <div className="sd-ser-content_wrap pb-90">
          <div className="container">
            <div className="sd-ser-content">
              <h2 className="sd-title">
                O desafio: infraestrutura local custosa e instável
              </h2>
              <p className="sd-content">
                Uma indústria alimentícia de médio porte enfrentava sérios
                problemas com sua infraestrutura local. Os servidores físicos
                apresentavam falhas constantes, gerando paradas não programadas
                que impactavam diretamente a produção. Os custos com manutenção
                de hardware, energia elétrica e refrigeração consumiam 35% do
                orçamento anual de TI. Além disso, a empresa não possuía um
                plano de disaster recovery adequado, colocando em risco dados
                críticos de controle de qualidade e rastreabilidade de produtos.
              </p>
              <br />
              <p className="sd-content">
                A situação se agravou quando um dos servidores principais falhou
                durante um período de alta demanda, causando 8 horas de
                inatividade e prejuízo estimado em R$ 450.000. A necessidade de
                uma solução robusta, econômica e altamente disponível tornou-se
                urgente para garantir a continuidade dos negócios e o
                crescimento sustentável da empresa.
              </p>
            </div>
          </div>
        </div>
        <div className="csd-ser_warp">
          <div className="container">
            <div className="csd-ser_inner ul_li_between">
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon1} alt="" />
                </div>
                <h6 className="xb-text">
                  cliente : <span> Indústria Alimentícia Regional</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon2} alt="" />
                </div>
                <h6 className="xb-text">
                  serviços : <span> Cloud VPS + Migração</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon3} alt="" />
                </div>
                <h6 className="xb-text">
                  conclusão : <span> 15 dias</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon4} alt="" />
                </div>
                <h6 className="xb-text">
                  localização : <span> Interior de SP, Brasil</span>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div className="sd-service_wrap pt-90 pb-130">
          <div className="container">
            <div className="sd-ser-outcome">
              <div className="sd-heading">
                <h2 className="sd-title">Requisitos do projeto</h2>
                <p className="sd-content">
                  O cliente necessitava de uma solução que oferecesse alta
                  disponibilidade, redução significativa de custos operacionais,
                  implementação de backup automático e disaster recovery, além
                  de suporte técnico 24/7 para garantir a continuidade
                  operacional do negócio.
                </p>
              </div>
              <div className="sd-list-item ul_li">
                <ul className="sd-ser-list list-unstyled">
                  <li>
                    <img src={cIcon} alt="" />
                    Auditoria completa da infraestrutura existente
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Dimensionamento adequado de recursos Cloud VPS
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Migração de dados sem interrupção do negócio
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Implementação de backup automático triplo
                  </li>
                </ul>
                <ul className="sd-ser-list list-unstyled">
                  <li>
                    <img src={cIcon} alt="" />
                    Configuração de monitoramento 24/7
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Treinamento da equipe interna
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Documentação técnica completa
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Suporte técnico especializado
                  </li>
                </ul>
              </div>
            </div>
            <div className="sd-heading csd-heading pt-90">
              <h2 className="sd-title">Solução implementada & resultados</h2>
              <p className="sd-content">
                <span>Solução:</span> Implementamos uma arquitetura Cloud VPS
                robusta com alta disponibilidade, utilizando servidores em nuvem
                com redundância automática. A migração foi executada em etapas,
                garantindo zero downtime durante o processo. Configuramos backup
                automático triplo com replicação em datacenters distintos,
                monitoramento proativo 24/7 e implementamos políticas de
                segurança avançadas.
              </p>
              <br />
              <p className="sd-content">
                <span>Resultados:</span> A empresa obteve 78% de redução nos
                custos operacionais de TI, 99.9% de disponibilidade do sistema,
                45% de melhoria na performance das aplicações e tempo de
                resposta 3x mais rápido. O RTO (Recovery Time Objective) foi
                reduzido de 8 horas para 15 minutos. A solução permitiu que a
                empresa reinvestisse os recursos economizados em melhorias de
                processo produtivo, resultando em crescimento de 25% na
                capacidade produtiva.
              </p>
            </div>

            <div className="similar-casestudy pt-80">
              <h2 className="similar-casestudy-title">Casos similares</h2>
              <div className="row mt-none-30">
                {caseStudies.slice(2, 5).map((cases, citem) => (
                  <div className="col-lg-4 col-md-6 mt-30" key={citem}>
                    <div className="casestudy-item">
                      <div className="casestudy-img">
                        <Link
                          onClick={ClickHandler}
                          to={`/casestudy-details/${cases.slug}`}
                        >
                          <img src={cases.img} alt="" />
                        </Link>
                        <div className="content_wrap">
                          <h3 className="item_title">{cases.title}</h3>
                          <span className="item_tag">{cases.slug}</span>
                        </div>
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to={`/casestudy-details/${cases.slug}`}
                        className="xb-overlay"
                      ></Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default CaseStudyMigracaoCloudVPS;
